import { postMailJoinTeam } from '../../../api';
import { messageSuccess } from '../../../components/message';
import { getLocationSearchParam, sleep } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';

export const joinStudioApi = async (inviteKey: string) => {
  const res = await postMailJoinTeam(inviteKey);
  if (res) {
    messageSuccess(getFormatMessage('join_success'));
    await sleep(1000); // 延迟1秒
    return true;
  }
  return false;
};

export const isNeedJoinStudio = () => {
  const isRoot = location.pathname === '/';
  const key = getLocationSearchParam('key');
  if (key?.trim() && isRoot) {
    return key.trim();
  }
  return '';
};
